import React, { useState } from 'react';
import { ViewFilters, View } from '@uncinc/react-drupal-core';
import { useDispatch, useSelector } from 'react-redux';
import { Container, CheckboxAndRadio, Form, Select, Button } from '../../../../components';
import { showMobileFilters, hideMobileFilters } from '../../../../actions/UI';
import useQueryParams from '../../../../helpers/useQueryString';

import './style.scss';

const ViewFilterElementCustom = (props) => {
  const mobileFiltersVisible = useSelector((state) => state.getIn(['uiInternal', 'showMobileFilters']));
  const { filter, onChange, defaultValues } = props;

  let defaultValue = null;
  const options = [];

  if (typeof filter === 'undefined') {
    return (
      <div className="filter-item">
        Filter undefined
      </div>
    );
  }

  switch (filter.get('plugin_id')) {
    case 'entity_reference_tree_inline_filter':
      defaultValue = defaultValues[filter.get('field')] || [];
      filter.get('options').map((option) => {
        options.push({ value: option.get('value'), label: option.get('label') });
      });

      if (defaultValues[filter.get('field')] && mobileFiltersVisible) {
        defaultValue = {
          value: defaultValues[filter.get('field')][0],
          label: options.filter((option) => option.value === defaultValues[filter.get('field')][0])[0].label,
        };
      }

      return (
        <div className="filter-item">
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          {mobileFiltersVisible ? (
            <Select
              name={filter.get('field')}
              id={filter.get('field')}
              handleChange={(option) => onChange(filter.get('field'), option.value)}
              options={options}
              defaultValue={defaultValue}
            />
          ) : (
            filter.get('options').map((option) => {
              return (
                <CheckboxAndRadio
                  type="checkbox"
                  key={`${filter.get('field')}:${option.get('value')}`}
                  name={filter.get('id')}
                  id={option.get('value')}
                  onChange={() => onChange(filter.get('field'), option.get('value'))}
                  label={option.get('label')}
                  checked={defaultValue.includes(option.get('value'))}
                  value={option.get('value') || defaultValue}
                />
              ); })
          )}
        </div>
      );

    case 'string':
      defaultValue = defaultValues[filter.get('field')] || '';

      return (
        <div className="filter-item input-with-unit input-with-unit--after" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <div className="input-container">
            <input
              type="text"
              name={filter.get('field')}
              id={filter.get('field')}
              defaultValue={defaultValue}
              placeholder={filter.getIn(['expose', 'placeholder'])}
              onChange={(e) => onChange(filter.get('field'), e.target.value)}
            />
            <div className="unit icon-after icon-search" />
          </div>
        </div>
      );

    default:
      return (
        <div className="filter-item">
          Filter Element: {filter.get('plugin_id')}
        </div>
      );
  }
};

const getFiltersFromParams = (params) => {
  const newFilters = {};

  if (params.title) {
    newFilters.title = params.title;
  }

  if (params.department) {
    newFilters.field_department_target_id = params.department.split(',');
  }

  if (params.area) {
    newFilters.field_address_target_id = params.area.split(',');
  }

  if (params.employment_type) {
    newFilters.field_employment_type_target_id = params.employment_type.split(',');
  }

  if (params.thinking_working_level) {
    newFilters.field_thinking_working_level_target_id = params.thinking_working_level.split(',');
  }

  return newFilters;
};

const ViewWithFilters = ({ entities, ...restProps }) => {
  const dispatch = useDispatch();
  const mobileFiltersVisible = useSelector((state) => state.getIn(['uiInternal', 'showMobileFilters']));

  // eslint-disable-next-line no-unused-vars
  const [params, setParams] = useQueryParams();
  const [filters, setFilters] = useState(getFiltersFromParams(params));

  const keyMap = {
    title: 'title',
    field_department_target_id: 'department',
    field_address_target_id: 'area',
    field_employment_type_target_id: 'employment_type',
    field_thinking_working_level_target_id: 'thinking_working_level',
  };

  const updateFilter = (field, value) => {
    const key = keyMap[field];

    if (key !== 'title' && !mobileFiltersVisible) {
      let array = (params[key] || '').split(',');

      if (array.includes(value)) {
        array = array.filter((item) => item !== value);
      }
      else {
        array.push(value);
      }
      value = array.filter((item) => item !== '').join(',');
    }

    const newParams = {
      ...params,
      [key]: value,
    };

    setParams(newParams);

    setFilters(getFiltersFromParams(newParams));
  };

  const toggleFilters = () => {
    if (mobileFiltersVisible) {
      dispatch(hideMobileFilters());
    } else {
      dispatch(showMobileFilters());
    }
  };

  return (
    <div className="ViewWithFilters">
      <Container>
        <div className="row">
          <div className="col-lg-4 ViewWithFilters__filter-column">
            <Button
              type="secondary"
              className="icon-filter_alt"
              onClick={() => toggleFilters()}
            >
              Filters
            </Button>
            <div className="ViewWithFilters__filters">
              <div className="ViewWithFilters__section-title">
                <h5>Filters</h5>
                <div className="link" onClick={() => { setParams({}); setFilters({}); }}>Wis filters</div>
              </div>
              <Form onSubmit={(e) => { e.preventDefault(); }}>
                <ViewFilters
                  viewId={restProps.id}
                  display={restProps.display}
                  onFilterUpdate={(field, value) => updateFilter(field, value)}
                  // eslint-disable-next-line react/no-unstable-nested-components
                  onRender={(props) => (
                    <ViewFilterElementCustom {...props} defaultValues={filters} />
                  )}
                />
                {mobileFiltersVisible && (
                  <div className="ViewWithFilters__actions">
                    <Button
                      type="transparent"
                      variation="center"
                      onClick={() => {
                        setParams({});
                        setFilters({});
                        dispatch(hideMobileFilters());
                      }}
                    >
                      Wis filters
                    </Button>
                    <Button type="primary" variation="center" htmlType="submit" onClick={() => dispatch(hideMobileFilters())}>
                      Toepassen
                    </Button>
                    <Button type="secondary" variation="center" onClick={() => dispatch(hideMobileFilters())}>
                      Annuleren
                    </Button>
                  </div>
                )}
              </Form>
            </div>
          </div>
          <div className="col-lg-8 ViewWithFilters--entity-column">
            <View {...restProps} filters={filters} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ViewWithFilters;
